import { updateProfileDataThunk } from '../../../../../store/workspace/thunks';
import { setDeleteFileModal } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import { TrashSquareIcon } from '../../../../../assets/icons/common';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import styles from './styles.module.scss';
import {
    selectProfileData,
    selectSelectedFileType,
    selectUpdatingProfileData,
} from '../../../../../store/workspace/selectors';

export default function DeleteFile() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfileData);
    const fileType = useSelector(selectSelectedFileType);
    const isLoading = useSelector(selectUpdatingProfileData);

    const submit = () => {
        if (!profile) return;
        const { kyc, matchedJobs, setting, ...rest } = profile;

        switch (fileType) {
            case 'Resume':
                rest.resumeFileKey = '';
                break;
            case 'Certificate':
                rest.certificateFileKey = '';
                break;
            case 'Cover':
                rest.coverLetterFileKey = '';
                break;
            case 'Portfolio':
                rest.portfolioFileKey = '';
                break;
            default:
                return;
        };

        dispatch(updateProfileDataThunk({ ...rest }));
    };

    return (
        <Modal
            size='sm'
            title='Delete File'
            icon={<TrashSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setDeleteFileModal(false))}
        >
            <h3>Are you sure you want to delete your {fileType === 'Cover' ? 'cover letter' : fileType} file ?</h3>
            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setDeleteFileModal(false))}
                />
                <Button
                    type='Error'
                    text='Delete'
                    onClick={submit}
                    loading={isLoading}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
